import { useLocalStorage } from "@mantine/hooks";
import { useMemo } from "react";

import { SavedBingoGame } from "bingo/types/saved.bingo.game.model";
import type { PlayerFormFields } from "common/models/player.model";

export const useSavedBingoGame = (bingoGameId: string) => {
  const [savedBingoGames, setSavedBingoGames] = useLocalStorage<
    Record<string, SavedBingoGame>
  >({
    key: "bingogames",
    getInitialValueInEffect: false,
  });

  return useMemo(
    () =>
      [
        (savedBingoGames || {})[bingoGameId],
        (
          playerId: string,
          partitionId: string,
          playerInfo: Omit<Partial<PlayerFormFields>, "termsOfService">,
        ) =>
          setSavedBingoGames((bingogames) => ({
            ...bingogames,
            [bingoGameId]: { playerId, partitionId, playerInfo },
          })),
      ] as const,

    [savedBingoGames, setSavedBingoGames, bingoGameId],
  );
};
